<template>
  <v-card class="mt-4">
    <v-card-title>
      <v-icon left>
        {{ icons.mdiQrcode }}
      </v-icon>
      チェックインQR
    </v-card-title>

    <v-card-text>
      <div
        v-if="loading"
        class="text-center py-4"
      >
        <v-progress-circular
          indeterminate
          size="24"
        />
      </div>

      <div
        v-else-if="checkinToken"
        class="d-flex flex-column align-center"
      >
        <div class="qr-wrapper elevation-1 mb-3">
          <canvas :id="canvasId" />
        </div>

        <p class="text-body-2 grey--text mb-3">
          トークン: {{ checkinToken }}
        </p>

        <div class="d-flex">
          <v-btn
            color="primary"
            outlined
            small
            class="mr-2"
            @click="regenerateToken"
          >
            <v-icon
              left
              small
            >
              {{ icons.mdiRefresh }}
            </v-icon>
            再発行
          </v-btn>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  ref, onMounted, nextTick, getCurrentInstance,
} from '@vue/composition-api'
import QrCode from 'qrcode'
import { mdiQrcode, mdiRefresh } from '@mdi/js'
import CheckinApi from '@/api/waiter/Checkin'

export default {
  name: 'CustomerCheckinQr',
  props: {
    customerId: { type: [Number, String], required: true },
  },
  setup(props) {
    const vm = getCurrentInstance().proxy
    const loading = ref(true)
    const checkinToken = ref(null)
    const canvasId = `checkin-qr-${props.customerId}`

    const generateQr = async token => {
      await nextTick()
      const canvas = document.getElementById(canvasId)
      if (canvas && token) {
        QrCode.toCanvas(canvas, token, { width: 200, margin: 2 }, err => {
          if (err) console.error('QRコード生成エラー:', err)
        })
      }
    }

    const fetchToken = async () => {
      loading.value = true
      try {
        const res = await CheckinApi.getCheckinQr(props.customerId)
        checkinToken.value = res.data.checkin_token
        loading.value = false
        await generateQr(checkinToken.value)
      } catch {
        loading.value = false
        vm.$toast.error('チェックイントークンの取得に失敗しました')
      }
    }

    const regenerateToken = async () => {
      // TODO: トークン再発行APIを呼び出す（Phase 2）
      vm.$toast.info('トークン再発行機能は今後実装予定です')
    }

    onMounted(() => {
      fetchToken()
    })

    return {
      loading,
      checkinToken,
      canvasId,
      regenerateToken,
      icons: { mdiQrcode, mdiRefresh },
    }
  },
}
</script>

<style scoped>
.qr-wrapper {
  display: inline-flex;
  padding: 12px;
  background: white;
  border-radius: 8px;
}
</style>
